<mat-card class="row  box-shadow ">

  <mat-card-content>
    <mat-tab-group>
      <mat-tab label="Mes future réservations">
        <app-book-table [bookList]='nextBook'></app-book-table>
      </mat-tab>
      <mat-tab label="Mes précédente réservations">
        <app-book-table [bookList]='oldBook'></app-book-table>
      </mat-tab>
    </mat-tab-group>
  </mat-card-content>
</mat-card>
